import { motion } from 'framer-motion';
import { fadeInUp, VIEWPORT_DEFAULT } from '@/lib/motion';

const TAGS = {
  div: motion.div,
  section: motion.section,
  li: motion.li,
  article: motion.article,
  span: motion.span,
};

/**
 * Fades + lifts children in once they scroll into view. Drop-in replacement
 * for the repeated `motion.div initial/whileInView` boilerplate scattered
 * across pages.
 */
const Reveal = ({
  as = 'div',
  variants = fadeInUp,
  delay = 0,
  viewport = VIEWPORT_DEFAULT,
  className,
  children,
  ...props
}) => {
  const Tag = TAGS[as] || motion.div;
  const resolvedVariants = delay
    ? { ...variants, show: { ...variants.show, transition: { ...variants.show?.transition, delay } } }
    : variants;
  return (
    <Tag
      initial="hidden"
      whileInView="show"
      viewport={viewport}
      variants={resolvedVariants}
      className={className}
      {...props}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
